<template>
  <div
    v-if="show"
    class="fa-3x text-primary fixed left-0 top-0 bg-dark bg-opacity-75 w-full h-full flex items-center justify-center z-50"
  >
    <i class="fas fa-sync fa-spin " />
  </div>
</template>
<script>
export default {
  name: 'XnWaiting',
  props: { show: { type: Boolean, default: false } },
}
</script>
